import { OrderItemType } from '@/generated-types/graphql.types';
import ListDropdown from '@/uikit/ListDropdown.vue';
import ListItem from '@/uikit/ListItem.vue';
import { computed, defineComponent } from '@vue/composition-api';
import { dateUnixTZ } from '@/util/dates';
import VATBreakdown from '@/Space/components/VATBreakdown.vue';
import { useBookingTimeSlots } from '@/util/dates';
import { SpaceOrderItemType } from '@/generated-types/graphql.types';
import { groupBy } from 'lodash';
import Popover from '@/components/Popover.vue';
import EventBus from '@/shared/services/eventBus';
import { imageUrl } from '@/util/images';
export default defineComponent({
    components: {
        ListDropdown,
        ListItem,
        VATBreakdown,
        Popover
    },
    props: {
        bookingSummary: {
            type: Object,
            default: null
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const { root, emit } = context;
        const spacePrice = computed(() => props.bookingSummary?.order.order_items.find(item => item.order_item_type === OrderItemType.Space)?.price);
        const services = computed(() => {
            const allServices = props.bookingSummary?.order.order_items.filter(item => item.order_item_type === OrderItemType.Service);
            // all services are grouped by the service type
            return (allServices && groupBy(allServices, service => service?.service_type));
        });
        const bookingDateTitle = computed(() => {
            const bookingDuration = (props.bookingSummary.slot_end - props.bookingSummary.slot_start) /
                3600;
            const bookingDay = dateUnixTZ(props.bookingSummary.slot_start, globalThis.$timezone);
            return bookingDuration
                ? bookingDay.format('D MMM YYYY')
                : root.$i18n.t('booking_summary.select_day');
        });
        const bookingRange = computed(() => {
            if (!props.bookingSummary.slot_start ||
                !props.bookingSummary.slot_end ||
                props.bookingSummary.slot_start === props.bookingSummary.slot_end)
                return '';
            return useBookingTimeSlots(props.bookingSummary, true);
        });
        const configuration = computed(() => props.bookingSummary.order.order_items.find(item => item.order_item_type === OrderItemType.Configuration));
        const removeService = (item) => {
            if (!props.editable) {
                return;
            }
            emit('removeService', item);
        };
        /*
         * This was a template literal, which is why the summary shows a broken
         * image with the alt text next to the space name.
         *
         * `${undefined}?tr:w-72` is the STRING "undefined?tr:w-72". It is never
         * empty, so `v-if="thumbnail"` in the template is always true, so the
         * <img> always mounts -- and for a space with no image row it mounts
         * pointing at a relative URL that 404s. The optional chaining looks like a
         * guard and guards nothing, because the interpolation happens after it.
         *
         * `?tr:w-72` was wrong independently: ImageKit's separator is `?tr=`, not
         * `?tr:`, so no transform was ever applied either.
         *
         * util/images.ts already does both jobs correctly -- it returns '' for a
         * falsy or non-addressable src, and returns a local path unchanged (the
         * mock seed uses /img/mock/space/0X.jpg, which exists in public/, so these
         * need no transform at all). Same call shape as Search/SpaceCard.vue.
         */
        const thumbnail = computed(() => imageUrl(props.bookingSummary.space?.space_images?.[0]?.image_url ?? '', {
            width: 72
        }));
        const onDateSectionClick = () => {
            emit('close');
            if (root.$mq.phone) {
                // Emit event to the WeekView.vue component
                EventBus.$emit('dateSectionClicked');
            }
        };
        return {
            bookingDateTitle,
            bookingRange,
            configuration,
            services,
            spacePrice,
            thumbnail,
            SpaceOrderItemType,
            onDateSectionClick,
            removeService
        };
    }
});
